// extracted by mini-css-extract-plugin
module.exports = {"container":"sitemap-item-module__container___BILRO","title":"sitemap-item-module__title___nLn0h","link":"sitemap-item-module__link___dJV0o"};